/* global System */
// register component(s) with react habitat

export default {
  TeamMember: () => System.import('./index'),
}
